/** @deprecated */
export const petriSpecs = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  CouponAlignmentInCartAndCheckout: 'specs.ecom.CouponAlignmentInCartAndCheckout',
  FixCartNavigationOnPreview: 'specs.ecom.FixCartNavigationOnPreview',
  RevampDiscountsInCartAndCheckout: 'specs.ecom.RevampDiscountsInCartAndCheckout',
  DontHandleCheckoutNotAllowedInCart: 'specs.ecom.DontHandleCheckoutNotAllowedInCart',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  ShowAdditionalFeesInSideCart: 'specs.ecom.ShowAdditionalFeesInSideCart',
  DisplayCheckoutErrorModalsForExpressButtons: 'specs.ecom.DisplayCheckoutErrorModalsForExpressButtons',
  FixCheckoutButtonAriaLabel: 'specs.ecom.FixCheckoutButtonAriaLabel',
  RemovePmNameErrorModal: 'specs.ecom.RemovePmNameErrorModal',
  SendRemoveLineItemAnalyticsFromCart: 'specs.ecom.SendRemoveLineItemAnalyticsFromCart',
} as const;

export const conductorSpecs = {
  ecomCartValidationsInPurchaseFlow: 'ecomCartValidationsInPurchaseFlow',
  ecomInlineAddressSelectionInCart: 'ecomInlineAddressSelectionInCart',
  ecomUseCartEstimationIndicators: 'ecomUseCartEstimationIndicators',
  ecomCartLineItemUpsells: 'ecomCartLineItemUpsells',
  ecomHideDeliveryErrorWhileUpdating: 'ecomHideDeliveryErrorWhileUpdating',
  ecomCartSkeletonColor: 'ecomCartSkeletonColor',
  ecomShowTotalSavings: 'ecomShowTotalSavings',
  ecomUseFullUrlInCartItemLink: 'ecomUseFullUrlInCartItemLink',
  ecomShowReducedDiscountAmount: 'ecomShowReducedDiscountAmount',
  ecomShowEstimateDeliveryOnSubdivisionError: 'ecomShowEstimateDeliveryOnSubdivisionError',
} as const;

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
} as const;
